'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginWithCustomToken = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

/**
 * Copyright 2017 Oursky Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Login with custom token.
 *
 * The custom token is typically created on an external server hosting a user
 * database. This server generates the custom token so that the user on an
 * external server can log in to Skygear Server.
 *
 * @injectTo {AuthContainer} as loginWithCustomToken
 * @param  {String} token - the token string
 * @return {Promise} promise
 *
 * @example
 * skygear.auth.loginWithCustomToken('eyXXXXXXXX').then(...);
 */
var loginWithCustomToken = exports.loginWithCustomToken = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(token) {
    var authResponse;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.container.makeRequest('sso:custom_token:login', { token: token });

          case 2:
            authResponse = _context.sent;
            return _context.abrupt('return', this._authResolve(authResponse));

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function loginWithCustomToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }